import {
  cuilGen,
  isValidDate,
  getParameterByName,
  getTrackingCodeLocal,
  obtenerTrackingCode,
  replaceAll,
  toTitleCase,
  isDev,
  get,
  normalizeCharacters
} from "@/utils/index";

describe("Utils full test", () => {
  describe("cuilGen", () => {
    it("should generate a valid CUIL", () => {
      expect(cuilGen("1234567", "HOMBRE")).toMatch("20012345675");
      expect(cuilGen("12345678", "HOMBRE")).toMatch("20123456786");
      expect(cuilGen("23456781", "HOMBRE")).toMatch("20234567811");
      expect(cuilGen("34567812", "HOMBRE")).toMatch("20345678124");
      expect(cuilGen("78123456", "HOMBRE")).toMatch("20781234568");
      expect(cuilGen("81234567", "HOMBRE")).toMatch("20812345673");
      expect(cuilGen("93456712", "HOMBRE")).toMatch("23934567129");
      expect(cuilGen("93456712", "HOMBRE")).toMatch("23934567129");

      expect(cuilGen("1234567", "MUJER")).toMatch("23012345674");
      expect(cuilGen("12345678", "MUJER")).toMatch("27123456780");
      expect(cuilGen("23456781", "MUJER")).toMatch("27234567816");
      expect(cuilGen("34567812", "MUJER")).toMatch("27345678129");
      expect(cuilGen("78123456", "MUJER")).toMatch("27781234562");
      expect(cuilGen("81234567", "MUJER")).toMatch("27812345678");

      expect(cuilGen("1234567", "SOCIEDAD")).toMatch("30012345670");
      expect(cuilGen("12345678", "SOCIEDAD")).toMatch("30123456781");
      expect(cuilGen("23456781", "SOCIEDAD")).toMatch("30234567817");
      expect(cuilGen("34567812", "SOCIEDAD")).toMatch("303456781210");
      expect(cuilGen("56781234", "SOCIEDAD")).toMatch("30567812347");
      expect(cuilGen("78123456", "SOCIEDAD")).toMatch("30781234563");
      expect(cuilGen("81234567", "SOCIEDAD")).toMatch("30812345679");
    });

    it("returns default value when property does not exist", () => {
      const obj = { a: { b: 1 } };
      expect(get(obj, "a.c", "default")).toBe("default");
    });
  });

  describe("replaceAll", () => {
    it("should replace all occurrences of a substring in a string", () => {
      const str = "Hello, World!";
      const search = "o";
      const replacement = "x";
      const expectedMock = "Hellx, Wxrld!";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
    it("should replace all occurrences of a substring in an empty string", () => {
      const str = "";
      const search = "a";
      const replacement = "x";
      const expectedMock = "";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
    it("should replace all occurrences of a substring in a string with no matches", () => {
      const str = "Hello, World!";
      const search = "x";
      const replacement = "y";
      const expectedMock = "Hello, World!";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
    it("should replace all occurrences of a substring in a string with multiple matches", () => {
      const str = "Hello, World!";
      const search = "l";
      const replacement = "x";
      const expectedMock = "Hexxo, Worxd!";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
  });

  describe("getParameterByName", () => {
    it("should return the value of the specified parameter from the URL", () => {
      const url = "https://example.com/?name=John&age=30";
      const name = "name";
      const expectedMock = "John";
      const result = getParameterByName(name, url);
      expect(result).toEqual(expectedMock);
    });
    it("should return null value when not exists parameters", () => {
      const url = "https://example.com/";
      const name = "name";
      const result = getParameterByName(name, url);
      expect(result).toBeNull();
    });
    it("should return empty value of the specified parameter from the URL with name", () => {
      const url = "https://example.com/?name=John&age=30&address=";
      const name = "address";
      const expectedMock = "";
      const result = getParameterByName(name, url);
      expect(result).toEqual(expectedMock);
    });
    it("should return empty value of the specified parameter from the URL empty", () => {
      const url = "";
      const name = "address";
      const result = getParameterByName(name, url);
      expect(result).toBeNull();
    });
  });

  describe("getTrackingCodeLocal", () => {
    beforeEach(() => {
      delete window.location;
      window.location = {
        href: "https://example.com/?track=UnTrack&origen=UnOrigen&cid=Un:tracking:viejo:de:Cid"
      };
    });

    it("should return the tracking code for the specified name", () => {
      expect(getTrackingCodeLocal("track")).toBe("UnTrack");
    });

    it("should return the tracking code for the specified name out params", () => {
      expect(obtenerTrackingCode()).toBe("-Un-tracking-viejo-de");
    });

    it("should return other tracking code for the out params not null", () => {
      delete window.location;
      window.location = {
        href: "https://example.com/?onsite=esto-es-un-valor-nuevo"
      };
      expect(getTrackingCodeLocal("onsite")).toBe("esto-es-un-valor-nuevo");
    });

    it("should return other tracking code for the out params", () => {
      delete window.location;
      window.location = {
        href: "https://example.com/"
      };
      expect(getTrackingCodeLocal("onsite")).toBeNull();
    });

    afterAll(() => {
      window.location.href = "";
    });
  });

  describe("toTitleCase", () => {
    it("should convert a string to title case", () => {
      const str = "hello, world!";
      const expectedMock = "Hello, World!";
      const result = toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
    it("should convert an empty string to an empty string", () => {
      const str = "";
      const expectedMock = "";
      const result = toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
    it("should convert a string with multiple words to title case", () => {
      const str = "this is a test";
      const expectedMock = "This Is A Test";
      const result = toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
  });

  describe("isValidDate", () => {
    it("should return TRUE if is a valid date", () => {
      expect(isValidDate("21/03/2024")).toBeTruthy();
    });

    it("should return FALSE if is a invalid date", () => {
      expect(isValidDate("32/03/2024")).toBeFalsy();
      expect(isValidDate("21/13/2024")).toBeFalsy();
      expect(isValidDate("21/03/3001")).toBeFalsy();
    });

    it("should return FALSE for an empty date", () => {
      expect(isValidDate("")).toBe(false);
    });
  });

  describe("normalizeCharacters", () => {
    it("should normalize special characters", () => {
      expect(normalizeCharacters("Nicolás")).toEqual("Nicolas");
    });

    it("should return the same parameter when it is not a string", () => {
      expect(normalizeCharacters(123)).toEqual("123");
    });

    it("should return the same string when the string is empty", () => {
      expect(normalizeCharacters("")).toEqual("");
    });
  });

  describe("isDev", () => {
    let originalProduction;

    beforeEach(() => {
      originalProduction = global.PRODUCTION;
    });

    afterEach(() => {
      global.PRODUCTION = originalProduction;
    });

    it("returns false when PRODUCTION is true", () => {
      global.PRODUCTION = true;

      expect(isDev()).toBe(true);
    });

    it("returns true when PRODUCTION is false", () => {
      global.PRODUCTION = false;

      expect(isDev()).toBe(true);
    });
  });
});